<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索仓库名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加仓库</el-button>
					<!-- <el-button type="danger" v-auth="'delAdmin'" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="仓库名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索仓库名稱"></el-input>
						</el-form-item>
						
						
						<el-form-item label="仓库類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="海外仓" :value="1"></el-option>
								<el-option label="中转仓" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="啟用狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="創建時間"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="開始日期"
							      end-placeholder="結束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
				<el-table-column align="center" prop="type" label="仓库類型" >
					<template slot-scope="v">
						<span v-if="v.row.type==1">海外仓</span>
						<span v-if="v.row.type==2">中转仓</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name" label="仓库图片">
					<template slot-scope="scope">
						<el-image 
							v-if="scope.row.head"
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name" label="仓库名稱">
				</el-table-column>
				
				
				<el-table-column align="center" width="140" prop="pt_name" label="绑定打印机">
				</el-table-column>
				<el-table-column align="center" prop="status" label="啟用狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			
				<el-table-column align="center" width="150" prop="addres" label="收件人">
				</el-table-column>
				<el-table-column align="center" prop="phone" label="收件電話">
				</el-table-column>
				<el-table-column align="center" prop="local" width="260" label="寄货地址">
				</el-table-column>
				
				
				
				<el-table-column align="center"  width="180" prop="create_time" label="創建時間">
				</el-table-column>
				<el-table-column prop="id" align="center" width="100" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改商戶' : '添加商戶'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">

			
				
				<el-form-item label="仓库類型">
					<el-radio-group :disabled="editIndex>0?true:false" v-model="form.type" size="small">
						<el-radio :label="1" border>海外仓</el-radio>
						<el-radio :label="2" border>中转仓</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				<el-form-item  label="仓库图片" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'godown'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon" :src="form.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				
				
				
				<el-form-item label="仓库名稱" prop="name">
					<el-input v-model="form.name" placeholder="仓库名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="收件人" prop="addres">
					<el-input v-model="form.addres" placeholder="收件人" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="收件電話" prop="phone">
					<el-input v-model="form.phone" placeholder="收件電話" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				<el-form-item label="寄货地址" prop="local">
					<el-input v-model="form.local" placeholder="地址" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item label="绑定打印机" prop="go_id">
					<el-select v-model="form.print_id"  size="small" filterable placeholder="請選擇" style="width: 85%;">
						<el-option  label="暂不绑定" :value="0">
						</el-option>
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="啟用狀態">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>啟用</el-radio>
						<el-radio :label="0" border>禁用</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					type:-1,
					time:[],
				},
				model_title: 'Godown',
				auth_val: 'Godown',
				preUrl: "data/godownList", //列表地址
				delAllUrl: "data/delGodownAll", //批量删除地址
				delUrl: "data/delGodown", //删除單条地址
				addUrl: "data/addGodown", //添加/修改地址
				editStatusUrl:"data/editStatusGodown",//修改狀態地址

				tableData: [],
				form: {
					id:0,
					name: "",
					local: '',
					headUrl: '',
					type:1,
					icon:'',
					status: 1,
					headId: 0,
					local:'',
					addres:'',
					phone:'',
					print_id:0
				},
				rules: {
					name: [{
							required: true,
							message: "仓库名稱不能為空",
							trigger: 'blur',
						},

					],
					addres: [{
							required: true,
							message: "收件人不能為空",
							trigger: 'blur',
						},
					
					],
					phone: [{
							required: true,
							message: "收件電話不能為空",
							trigger: 'blur',
						},
					
					],
					local: [{
							required: true,
							message: "寄货地址不能為空",
							trigger: 'blur',
						},

					],
					
					

				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('printData');
		},
		methods: {
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: "",
						local: '',
						headUrl: '',
						icon:'',
						status: 1,
						type:1,
						headId: 0,
						local:'',
						addres:'',
						phone:'',
						print_id:0
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						password2: '',
						headUrl: e.row.head,
						icon:e.row.head,
						type:e.row.type,
						headId: 0,
						local:e.row.local,
						status: e.row.status,
						addres:e.row.addres,
						phone:e.row.phone,
						print_id:e.row.print_id
					}
				
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule_list = list

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							if (!isJPG) {
							  this.$message.error('文件格式错误!');
							}
							if (!isLt2M) {
							  this.$message.error('上傳图片大小不能超過 2MB!');
							}
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					status:-1,
					
					type:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
